import { Model } from "./Model";
import { Place } from "./Place";
import { Phone } from "./Phone";
import { Contact } from "./Contact";
import { ContractStatuses } from "../constants/contract-enums";

export class Contract extends Model {
  static props = {
    id: { type: Number, required: true },
    project_id: { type: Number },
    name: { type: String, default: "" },
    type: { type: String, default: ContractStatuses.ACTIVE },
    primary_contact: { type: Contact, required: true },
    primary_contact_id: { type: Number, required: true },
    additional_contacts: { type: Array, default: [] },
    additional_contact_ids: { type: Array, default: [] },
    partner_contacts: { type: Array, default: [] },
    contacts: { type: Array, default: [] },
    place: { type: Place },
    billing_place: { type: Place },
    email: { type: String, default: "" },
    primary_phone: {
      type: Phone,
      default: new Phone()
    },
    additional_phones: { type: Array, default: [] },
    gate_code: { type: String, default: "" },
    note: { type: Object, default: { text: null } },
    project_name: { type: String }
  };

  /**
   * @param parameters  Object
   */
  constructor(parameters) {
    super(Contract.props, parameters);
  }

  mapParametersToModel(parameters, props) {
    super.mapParametersToModel(parameters, props);

    if (parameters.additional_contacts) {
      this.additional_contacts = parameters.additional_contacts.map(contact => {
        if (contact.constructor === Object) {
          return new Contact(contact);
        }
        return contact;
      });
    }

    if (parameters.partner_contacts) {
      this.partner_contacts = parameters.partner_contacts.map(contact => {
        if (contact.constructor === Object) {
          return new Contact(contact);
        }
        return contact;
      });
    }

    if (parameters.contacts) {
      this.contacts = parameters.contacts.map(contact => {
        if (contact.constructor === Object) {
          return new Contact(contact);
        }
        return contact;
      });
    }
  }

  get primaryContactName() {
    if (this.primary_contact && this.primary_contact.name) {
      return this.primary_contact.name;
    }
    return "";
  }

  get primaryPhoneNumber() {
    if (this.primary_phone && this.primary_phone.number) {
      return this.primary_phone.number;
    }
    return "";
  }
}
